import React from 'react';
import { useTranslation } from 'react-i18next';
import './ReturnPolicy.css';

const ReturnPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="return-container" style={{paddingTop: '5rem'}}>
      <div className="return-content">
        {/* Header */}
        <div className="return-header">
          <h1>{t('returnPolicy.title')}</h1>
          <p className="return-date">{t('returnPolicy.lastUpdated')}: {t('returnPolicy.date')}</p>
        </div>

        {/* Welcome Section */}
        <section className="return-section">
          <p className="return-intro">{t('returnPolicy.welcome')}</p>
        </section>

        {/* 1. Return Period */}
        <section className="return-section">
          <h2>{t('returnPolicy.section1.title')}</h2>
          <p>{t('returnPolicy.section1.content1')}</p>
          <p>{t('returnPolicy.section1.content2')}</p>
          <div className="highlight-box">
            <strong>{t('returnPolicy.section1.important')}</strong> {t('returnPolicy.section1.content3')}
          </div>
        </section>

        {/* 2. Eligible Returns */}
        <section className="return-section">
          <h2>{t('returnPolicy.section2.title')}</h2>
          <p>{t('returnPolicy.section2.content1')}</p>
          <ul>
            <li>{t('returnPolicy.section2.item1')}</li>
            <li>{t('returnPolicy.section2.item2')}</li>
            <li>{t('returnPolicy.section2.item3')}</li>
            <li>{t('returnPolicy.section2.item4')}</li>
          </ul>
        </section>

        {/* 3. Non-Returnable Items */}
        <section className="return-section">
          <h2>{t('returnPolicy.section3.title')}</h2>
          <p>{t('returnPolicy.section3.content1')}</p>
          <ul>
            <li>{t('returnPolicy.section3.item1')}</li>
            <li>{t('returnPolicy.section3.item2')}</li>
            <li>{t('returnPolicy.section3.item3')}</li>
            <li>{t('returnPolicy.section3.item4')}</li>
          </ul>
        </section>

        {/* 4. Return Process */}
        <section className="return-section">
          <h2>{t('returnPolicy.section4.title')}</h2>
          <p>{t('returnPolicy.section4.content1')}</p>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>{t('returnPolicy.section4.step1Title')}</h3>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>{t('returnPolicy.section4.step2Title')}</h3>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>{t('returnPolicy.section4.step3Title')}</h3>
              </div>
            </div>
          </div>
        </section>

        {/* 5. Refund Process */}
        <section className="return-section">
          <h2>{t('returnPolicy.section5.title')}</h2>
          <p>{t('returnPolicy.section5.content1')}</p>
          <p>{t('returnPolicy.section5.content2')}</p>
          <p>{t('returnPolicy.section5.content3')}</p>
          <p>{t('returnPolicy.section5.content4')}</p>
          
        </section>

        {/* 6. Exchange Policy */}
        <section className="return-section">
          <h2>{t('returnPolicy.section6.title')}</h2>
          <p>{t('returnPolicy.section6.content1')}</p>
          <p>{t('returnPolicy.section6.content2')}</p>
          <p>{t('returnPolicy.section6.content3')}</p>
        </section>

        {/* 7. Return Shipping */}
        <section className="return-section">
          <h2>{t('returnPolicy.section7.title')}</h2>
          <p>{t('returnPolicy.section7.content1')}</p>
          <ul>
            <li>{t('returnPolicy.section7.item1')}</li>
            <li>{t('returnPolicy.section7.item2')}</li>
          </ul>
        </section>

        {/* 8. Damaged or Defective Items */}
        <section className="return-section">
          <h2>{t('returnPolicy.section8.title')}</h2>
          <p>{t('returnPolicy.section8.content1')}</p>
          <p>{t('returnPolicy.section8.content2')}</p>
        </section>

        {/* 9. Contact for Returns */}
        <section className="return-section">
          <h2>{t('returnPolicy.section9.title')}</h2>
          <p>{t('returnPolicy.section9.content1')}</p>
          <div className="contact-info">
            <p><strong>{t('returnPolicy.section9.email')}:</strong> store@beautypro.ge</p>
            <p><strong>{t('returnPolicy.section9.phone')}:</strong> +995 577 188 177</p>
            <p><strong>{t('returnPolicy.section9.hours')}:</strong> {t('returnPolicy.section9.hoursValue')}</p>
          </div>
        </section>

        {/* Footer Note */}
        <div className="return-footer">
          <p>{t('returnPolicy.footer')}</p>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;